import { Component, Input, ChangeDetectionStrategy,
         ChangeDetectorRef } from '@angular/core';

import { DataSource } from '../../datasource';


@Component({
  selector: 'igo-time-filter-list',
  template: require('./time-filter-list.component.html'),
  styles: [require('./time-filter-list.component.styl')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeFilterListComponent {

  @Input()
  get datasources(): DataSource[] { return this._dataSources; }
  set datasources(value: DataSource[]) {
    this._dataSources = value;
    this.cdRef.detectChanges();
  }
  private _dataSources: DataSource[] = [];

  constructor(private cdRef: ChangeDetectorRef) {}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/filter/time-filter-list/time-filter-list.component.ts